import { memo, useMemo } from "react";

import { FeatureIslandContainer } from "@/components/features/_layouts";

import { ReferenceArticles, SettingsSiteControllerHeader } from "../_shared";
import { REFERENCE_ARTICLES } from "./constants";
import { useSettingsSiteControllerNotUsing } from "./hooks";
import { SettingsSiteControllerNotUsingMain } from "./main";

import type { SiteControllerSettingBaseFormModel } from "../../../model/base/type";
import type { SiteControllerSettingBaseFormModelMethodsType } from "../../../model/base/use-case/use-create-model/methods";
import type { SiteControllerSettingBaseFormModelOnSetViewModelType } from "../../../model/base/use-case/use-create-model/use-create-model";

type Props = {
	viewModel: SiteControllerSettingBaseFormModel["ViewModel"]; //
	onSetViewModel: SiteControllerSettingBaseFormModelOnSetViewModelType;
	resetViewModel: () => void;

	siteControllerSettingBaseFormModelMethodsType: SiteControllerSettingBaseFormModelMethodsType;

	queryData: Pick<SiteControllerSettingBaseFormModel["QueryData"], "isSiteControllerRegistered">;
};

export const SettingsSiteControllerNotUsing = memo(
	({ viewModel, siteControllerSettingBaseFormModelMethodsType, resetViewModel, queryData }: Props) => {
		const { onUpdate } = useSettingsSiteControllerNotUsing({
			hotelID: viewModel.hotelID,
			onResetViewModel: resetViewModel,
		});

		const isValid = useMemo(() => {
			if (!queryData.isSiteControllerRegistered) {
				// 「CHILLNNで管理する」が選択されている & サイトコントローラーが登録が完了していない場合（初期設定時）
				return true;
			}

			return viewModel.isDirty && !viewModel.hasError;
		}, [viewModel.hasError, viewModel.isDirty, queryData.isSiteControllerRegistered]);

		return (
			<FeatureIslandContainer>
				<SettingsSiteControllerHeader onUpdate={onUpdate} isValid={isValid} />

				<ReferenceArticles articles={REFERENCE_ARTICLES} />

				<SettingsSiteControllerNotUsingMain
					hotelID={viewModel.hotelID}
					viewModel={viewModel}
					siteControllerSettingBaseFormModelMethodsType={siteControllerSettingBaseFormModelMethodsType}
				/>
			</FeatureIslandContainer>
		);
	},
);

SettingsSiteControllerNotUsing.displayName = "SettingsSiteControllerNotUsing";
